var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner"}),_c('div',{staticClass:"text"},[_vm._v("Loading....")])])
}]

export { render, staticRenderFns }